import React from 'react';
import '../common.scss';
import './styles.scss';
import clsx from 'clsx';
import Components from './components';
import { useCustomComponent } from '@/hooks';

export interface FormGroupProps {
  children: React.ReactNode;
  index?: number;
  label?: string;
  error?: string;
  htmlFor?: string;
  required?: boolean;
  className?: string;
}

const FormGroupComponent: React.FC<FormGroupProps> = ({
  children,
  index,
  label,
  error,
  htmlFor,
  required = false,
  className = '',
}) => {
  return (
    <Components.Container
      className={clsx('peptalk-form-group', 'fade-in-up', className)}
      animationDelayS={index ? index * 0.1 : 0}
    >
      {label && (
        <Components.Label htmlFor={htmlFor} required={required}>
          {label}
        </Components.Label>
      )}
      {children}
      {error && <Components.Error>{error}</Components.Error>}
    </Components.Container>
  );
};

export const FormGroup: React.FC<FormGroupProps> = (props: FormGroupProps) => {
  const Component = useCustomComponent({
    componentName: 'FormGroup',
    Component: FormGroupComponent,
  });

  return <Component {...props} />;
};
